import React from 'react'
import { Outlet, Link, useLocation } from 'react-router'
import { useAuth } from '../hooks/useAuth'
import Header from './Header'

const Layout = () => {
  const location = useLocation()
  const { isAdmin } = useAuth()

  const isAdminRoute = location.pathname.startsWith('/admin')

  return (
    <div className="min-h-screen flex flex-col">
      <Header />

      <main className="flex-1">
        <Outlet />
      </main>
    </div>
  )
}

export default Layout